<template>
  <div class="yubikey-factor-component">
    <p class="color-white">Yubikey</p>

    <p>
      <a-input type="password" ref="yubikey" v-model="value"
               v-on:keyup.enter.native.prevent="onSubmit"
               v-bind:class="{'has-error': !yubikeyValid}"
               v-on:focus="() => {yubikeyValid = true}"
               v-on:blur="validateYubikey"
      >
        <img slot="prefix" src="/img/yubikey.png" height="20" style="margin-left: -5px;"/>
      </a-input>
    </p>

    <a-button :loading="loading" size="large" type="primary" block
              v-on:click="onSubmit" style="margin-bottom: 40px;">
      Inloggen
    </a-button>

    <p class="color-white">
      Heeft u uw yubikey niet bij de hand klik dan op de link hieronder om een code via de mail te ontvangen.
    </p>


    <a-button type="link" block ghost @click="onLoginFactorEmailClick">
      Inloggen met e-mail code
    </a-button>
  </div>
</template>

<script>
import authApi from "~/api/auth";
import ForgotPasswordComponent from "./ForgotPasswordComponent";

export default {
  name: "YubikeyFactorComponent",
  props: {},
  data() {
    return {
      value: '',
      loading: false,
      yubikeyValid: true,
    }
  },
  computed: {},
  methods: {
    validateYubikey(e) {
      // let emailRegex = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

      this.yubikeyValid = (
          (this.value.length > 0)
      );
    },
    onSubmit() {
      this.loading = true;
      this.$emit('submit', this.value);
    },
    onCancelClick() {
      this.$emit('cancel');
    },
    onLoginFactorEmailClick() {
      this.$emit('switch-factor', 'email');
    },
  },
  mounted() {
    setTimeout(() => {
      this.$refs.yubikey.focus();
    }, 500);
  }
}
</script>

<style>
.yubikey-factor-component .ant-input-affix-wrapper input.ant-input {
  padding-left: 55px !important;
}
</style>
